import { render, staticRenderFns } from "./ShowContractDetailsModal.vue?vue&type=template&id=71fe6bf4&scoped=true&lang=pug"
import script from "./ShowContractDetailsModal.vue?vue&type=script&lang=js"
export * from "./ShowContractDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fe6bf4",
  null
  
)

export default component.exports